import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import BM10090View from "../../Views/Bases/BM10090";
import Snackbar from "../../Components/Snackbar";

function BM10090(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({
    comboPlantCd: [],
    whCd: "",
    plantCd: "P100",
    result: false,
  });
  const [inputs, setInputs] = React.useState({
    comboList: [],
    comboValue: "",
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
        inputs.comboList = getComboData.filter(
          (e) => e.groupCd == "WH_GUBUN" && e.value != "WH_GUBUN"
        );
        checkInputs.comboPlantCd = getComboData.filter(
          (e) => e.groupCd == "PLANT_CD" && e.value != "PLANT_CD"
        );
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10090.GetWh
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            plantCd: data[i].plantCd,
            whCd: data[i].whCd,
            whNm: data[i].whNm,
            whGubun: data[i].whGubun,
            whGubunNm: data[i].whGubunNm,
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            createId: data[i].createId,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
          });
        }
      });
      setRowData(getRowData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckKeys = async () => {
    Dialog.ProgressBar(true);

    if (checkInputs.whCd === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_CheckWhCd" && f.lanType === "SNACK"
        )[0].lanName,
      });
      Dialog.ProgressBar(false);
      return;
    }
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10090.CheckCode,
        {
          whCd: checkInputs.whCd,
        }
      ).then((result) => {
        let data = result.data;

        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            whCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < updateData.length; i++) {
        getData.push({
          whCd: updateData[i].whCd,
          newYn: "Y",
          whGubun: updateData[i].whGubunNm
            ? updateData[i].whGubunNm.value
            : null,
          whNm: updateData[i].whNm,
          createId: userInfo.userId,
          updateId: userInfo.userId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10090.Create,
        updateData.length === 0 ? saveData : getData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let tranData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < selectedRowData.length; i++) {
        tranData.push({
          plantCd: selectedRowData[i].plantCd,
          whCd: selectedRowData[i].whCd,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10090.Delete,
        tranData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <BM10090View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        inputs={inputs}
        setInputs={setInputs}
        CheckKeys={CheckKeys}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10090;
